import { RESET_CTR_SECTION_SUCCESS } from '.';

export default payload => ({
  type: RESET_CTR_SECTION_SUCCESS,
  payload,
});
